/* eslint-disable react/prop-types */
import { Box, Typography } from '@material-ui/core'
import React from 'react'
import ErrorIcon from '@material-ui/icons/Error'

const ErrorMessage = ({ message }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    width="100%"
    height="100%"
  >
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
    >
      <ErrorIcon color="error" />
      <Typography
        variant="body1"
        style={{ fontWeight: 'bold' }}
        color="error"
      >
        {message || 'Maaf, Terjadi Kesalahan Sistem'}
      </Typography>

    </Box>
  </Box>
)

export default ErrorMessage
